"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ResultWithData_1 = require("./ResultWithData");
/**
 * Represents a state transition, maybe to the same state.
 * Updates the state machine's data
 */
var NextStateWithData = /** @class */ (function (_super) {
    __extends(NextStateWithData, _super);
    /**
     * @param nextState - the next state to go to
     * @param newData - new state machine data
     * @param actions - transition actions
     */
    function NextStateWithData(nextState, newData) {
        var actions = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            actions[_i - 2] = arguments[_i];
        }
        var _this = _super.apply(this, [newData].concat(actions)) || this;
        _this.nextState = nextState;
        /**
         * @hidden
         * @type {"nextState"}
         */
        _this.type = "nextState";
        return _this;
    }
    return NextStateWithData;
}(ResultWithData_1.default));
exports.default = NextStateWithData;
//# sourceMappingURL=NextStateWithData.js.map